export default __webpack_public_path__ + "static/media/kh.2fbda01f.svg";